<template>
  <div class="task-course-cell" @click="courseTaskClick">
    <div class="tag">
      <img class="course-img" src="../../../assets/images/home/course.png" />
      <!-- <img v-else class="course-img" src="../../../assets/images/home/courseLock.png" /> -->
    </div>
    <div class="right-content" :class="{ 'hide-bottom-line': hideBottomLine }">
      <div class="task-name-wrap" v-if="taskData.courseType == 2">
        <div class="task-name-long" :style="{ color: '#1f333f' }">
          {{ taskData && taskData.courseDisplayName }}
        </div>
        <div class="courseType">选修</div>
      </div>
      <div v-else class="task-name" :style="{ color: '#1f333f' }">
        {{ taskData && taskData.courseDisplayName }}
      </div>
      <div class="task-state-label">
        <div class="label-item">
          <template>
            <img v-if="`${taskData.isUnlock}` === '1' && !taskData.myUnlock" src="@/assets/images/data-base/unlock.png"
              class="icon-unlock" alt="">
            <div class="click-btn" v-if="taskData.learningStatus === '3'">
              未开始
            </div>
            <!-- <div v-else-if="taskShowState === ECourseTaskShowState.UnFinishLabel" class="state-label-text">
              未开始
            </div> -->
            <div v-else-if="taskData.learningStatus === '2'" class="state-label-text">
              进行中
            </div>
            <img v-else-if="taskData.learningStatus === '1'" class="finish-icon" :src="iconFinishTask" />
          </template>
          <!-- <template v-else>
            <img class="course-opened-icon" :src="courseOpenedIcon" />
          </template> -->
        </div>
      </div>
    </div>
    <dialog-unlock ref="dialogUnlock" @unlockSuccess="handleGotoDetails" :dataProps="dataProps"></dialog-unlock>
  </div>
</template>

<script>
import dialogUnlock from '@/components/dialogUnlock.vue'
import {isScorm} from '../../../api/scorm'
export default {
  name: 'TaskCell',
  components: { dialogUnlock },
  props: {
    taskData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    hideBottomLine: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dataProps: {
        unlockContent: '兑换EP公开课课程',
        unlockTxt: '课程'
      }
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
    iconFinishTask () {
      return require('../../../assets/images/person/true.png')
    }
  },
  methods: {
    courseTaskClick () {
      if (`${this.taskData.isUnlock}` === '1' && !this.taskData.myUnlock) {
        this.dataProps.baseId = this.taskData.courseDetails.id
        // journeyId
        this.dataProps.unlockCost = this.taskData.unlockCost
        this.$refs.dialogUnlock.dailogShow = true
        return
      }
      this.handleGotoDetails()
    },
    async handleGotoDetails () {
      window.sessionStorage.setItem('entrance', '12')
      const query = {
        trainTaskId: this.taskData.id || '',
        trainId: this.taskData.trainId || '',
        studyState: this.taskData.studyState,
        courseEType: this.taskData.courseEtype,
        studentUserId: this.userInfo ? this.userInfo : '',
        courseId: this.taskData.courseId,
        journeyId: this.taskData.journeyId,
        businessId: this.taskData.journeyId,
        entrance: '12',
        channel: '12'
      }
      const isscorm = await isScorm(this.taskData.courseId)
      let path = '/courserDetails'
      if (isscorm.data) {
        path = '/scormCourseDetail'
      }
      this.$router.push({path, query})
    }
  }
}
</script>

<style lang="less" scoped>
.task-course-cell {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #1f333f;
  height: 48px;
  line-height: 48px;
  position: relative;

  .tag {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    margin-right: 13px;
    width: 32px;
    height: 16px;

    .course-img {
      width: 100%;
      height: 100%;
    }
  }

  .right-content {
    flex: 1;
    display: flex;
    align-items: center;
    width: calc(100% - 45px);

    &.hide-bottom-line {
      border-bottom: none;
    }

    .task-name {
      margin-right: 3px;
      flex: 1;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 160px;
      height: 17px;
      font-size: 12px;
      font-family: AppleSystemUIFont;
      color: #1f262f;
      line-height: 17px;
    }

    .task-name-wrap {
      margin-right: 13px;
      flex: 1;
      display: flex;
      align-items: center;

      .task-name-long {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 160px;
        height: 17px;
        font-size: 12px;
        font-family: AppleSystemUIFont;
        color: #1f262f;
        line-height: 15px;
      }

      .courseType {
        padding: 3px 5px;
        background: #f4f4f4;
        border-radius: 4px;
        font-size: 10px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        color: #999999;
        line-height: 1;
        margin-left: 10px;
      }
    }

    .task-state-label {
      .label-item {
        display: flex;
        align-items: center;

        .icon-unlock {
          width: 10px;
          margin-right: 4px;
          display: block;
        }

        .click-btn {
          padding: 2px 7px;
          color: #ffffff;
          background: #EB1700;
          border-radius: 20px;
          font-size: 10px;
          font-weight: 500;
          line-height: 16px;
        }

        .finish-icon {
          width: 16px;
          height: 16px;
        }

        .state-label-text {
          font-size: 11px;
          font-weight: 500;
          color: #EB1700;
        }

        .course-opened-icon {
          width: 16px;
          height: 16px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/TaskCell.vue